const $ = jQuery;

export default () => {
  //////////////////
  // Docs https://animejs.com/

  //////////////////
  // Default example
  anime({
    targets: '.css-selector-demo .el',
    translateX: 250
  });
};
